import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    TextField,
    Typography,
    InputLabel,
    Card,
    Select,
    Icon,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import MKInput from 'components/MKInput';
import SearchIcon from "@mui/icons-material/Search";
import MKAvatar from "components/MKAvatar";
import FormControl from '@mui/material/FormControl';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { LocationOn } from '@mui/icons-material';
import Logo from "assets/images/skill2.png";
import { useLocation } from 'react-router-dom';
import Slider from '@mui/material/Slider';
import { useNavigate } from 'react-router-dom';
import '../../../styles.css';

function valuetext(value) {
    return `${value}`;
}

const sidebarStyles = {
    width: '350px',
    // backgroundColor: 'rgba(0, 0, 50, 0.2)', // Blue with 50% transparency
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
};

const Page = () => {
    // const styles = {
    //     gridItem: {
    //         border: '1px double #ccc',
    //         borderRadius: '30px',
    //         padding: '16px',
    //         marginBottom: '16px',
    //         boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    //         width: '1000px',
    //         backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
    //     },
    //     trainingInfo: {
    //         display: 'flex',
    //         flexDirection: 'column',
    //     },
    //     trainingName: {
    //         marginTop: '-10px',
    //         marginBottom: '8px',
    //         fontSize: 'medium',
    //         color: 'rgb(60, 150, 190)'
    //     },
    //     gridContent: {
    //         padding: '13px',
    //     },
    // };

    const [trainingName, setTrainingName] = useState("");
    const [search, setSearch] = useState("");
    const [inputValue, setInputValue] = useState('');
    const [modeOfTraining, setModeOfTraining] = useState("");
    const [location, setLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetRangeFrom, setBudgetRangeFrom] = useState("");
    const [budgetRangeTo, setBudgetRangeTo] = useState("");
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainerList, setTrainerList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTrainer, setSelectedTrainer] = useState('');
    const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
    const [travelWithinCountry, setTravelWithinCountry] = useState("");
    const [travelOutsideCountry, setTravelOutsideCountry] = useState("");
    const [weekendTraining, setWeekendTraining] = useState("");
    const [individualTraining, setIndividualTraining] = useState("");
    const [recordTraining, setRecordTraining] = useState("");
    const [minYear, setMinYear] = useState("");
    const [maxYear, setMaxYear] = useState("");
    const [timeZone, setTimeZone] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [minTrainingDelivered, setMinTrainingDelivered] = useState("");
    const [maxTrainingDelivered, setMaxTrainingDelivered] = useState("");
    const pageSize = 5;

    const minYearOptions = Array.from({ length: 21 }, (_, index) => index);
    const maxYearOptions = Array.from({ length: 21 }, (_, index) => index);

    const minTrainingDeliveredOptions = Array.from({ length: 10 }, (_, index) => index);
    const maxTrainingDeliveredOptions = Array.from({ length: 51 }, (_, index) => index);

    const handleSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinYear(minValue);
        setMaxYear(maxValue);
    };

    const handleTrainingSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinTrainingDelivered(minValue);
        setMaxTrainingDelivered(maxValue);
    };

    const timeZones = moment.tz.names();

    const handleTimeZoneChange = (newValue) => {
        setTimeZone(newValue);
    };
    console.log("timeZone", timeZone);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const handleSearchChange = (event, value) => {
        setSearch(value);
    };
    console.log("search", search);

    const handleBudgetChange = (e) => {
        const newValue = e.target.value;
        setBudget(newValue);
        if (newValue === "0-1000") {
            setBudgetRangeFrom(0);
            setBudgetRangeTo(1000);
        } else if (newValue === "1000-5000") {
            setBudgetRangeFrom(1000);
            setBudgetRangeTo(5000);
        } else if (newValue === "5000-10000") {
            setBudgetRangeFrom(5000);
            setBudgetRangeTo(10000);
        } else if (newValue === "10000-20000") {
            setBudgetRangeFrom(10000);
            setBudgetRangeTo(20000);
        } else if (newValue === ">20000") {
            setBudgetRangeFrom(20000);
            setBudgetRangeTo('');
        }
    };

    console.log("budget", budget);
    console.log("budgetRangeFrom", budgetRangeFrom);
    console.log("budgetRangeTo", budgetRangeTo);

    const onSubmitClick = async () => {
        const filteredList = filterTrainerList();
        setTrainerList(filteredList);
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/trainer-page-less/?avgCommercialFor8hrs__gte=${budgetRangeFrom}&avgCommercialFor8hrs__lte=${budgetRangeTo}&skills__icontains=${search}&location__icontains=${location}&page=${currentPage}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainerList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [budgetRangeFrom, budgetRangeTo, search, location, currentPage]);

    console.log("trainerList", trainerList);
    console.log("data", bbdata);

    const totalPages = Math.ceil(trainerList.length / pageSize);

    const urlPath = useLocation();
    const queryParams = new URLSearchParams(urlPath.search);

    const asearch = queryParams.get('search');
    const alocation = queryParams.get('location');
    const abudgetRangeFrom = queryParams.get('budgetRangeFrom');
    const abudgetRangeTo = queryParams.get('budgetRangeTo');

    console.log("hi");
    console.log("search", asearch);
    console.log("location", alocation);
    console.log("budgetRangeFrom", abudgetRangeFrom);
    console.log("budgetRangeTo", abudgetRangeTo);

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };
    console.log("fromDate", fromDate);

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    console.log("toDate", toDate);

    useEffect(() => {
        if (asearch !== search) {
            setSearch(asearch);
        }

        if (alocation !== location) {
            setLocation(alocation);
        }

        if (abudgetRangeFrom !== budgetRangeFrom) {
            setBudgetRangeFrom(abudgetRangeFrom);
        }

        if (abudgetRangeTo !== budgetRangeTo) {
            setBudgetRangeTo(abudgetRangeTo);
        }
    }, [asearch, alocation]);

    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setLocation("");
        setTravelWithinCountry("");
        setTravelOutsideCountry("");
        setWeekendTraining("");
        setIndividualTraining("");
        setMinYear("");
        setMaxYear("");
        setTimeZone("");
        setRecordTraining("");
    };

    const filterTrainerList = () => {
        return trainerList.filter((trainer) => {
            const travelWithinCountryMatch = !travelWithinCountry || trainer.travelWithInYourCountry === travelWithinCountry;
            const travelOutsideCountryMatch = !travelOutsideCountry || trainer.travelOutSideCountry === travelOutsideCountry;
            const weekendTrainingMatch = !weekendTraining || trainer.weekendTraining === weekendTraining;
            const individualTrainingMatch = !individualTraining || trainer.individualTraining === individualTraining;
            const minYearMatch = !minYear || trainer.totalExperience >= minYear;
            const maxYearMatch = !maxYear || trainer.totalExperience <= maxYear;
            const timeZoneMatch = !timeZone || trainer.workingTimeZone.includes(timeZone);
            const recordTrainingMatch = !recordTraining || trainer.recordTraining === recordTraining;

            return (
                travelWithinCountryMatch &&
                travelOutsideCountryMatch &&
                weekendTrainingMatch &&
                individualTrainingMatch &&
                minYearMatch &&
                maxYearMatch &&
                timeZoneMatch &&
                recordTrainingMatch
            );
        });
    };


    const navigate = useNavigate();

    const onMoreDetailsClick = (training) => {
        console.log("training1111111", training);
        console.log("token111111111", localStorage.getItem("token"));
        if (localStorage.getItem("token") !== "" || localStorage.getItem("token") !== null) {
            console.log("helloooooooooooooo");
            navigate('/pages/authentication/trainingcompanysign-in', { state: { redirectUrl: `/app/recommendedtrainermoredetails/${training.user_id}/` } });
        } else {
            console.log("aaaaaaaaaaaaaaaaaaaaa");
            navigate(`/app/recommendedtrainermoredetails/${training.user_id}/`);
        }

    };

    const getCurrentPageData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return filterTrainerList().slice(startIndex, endIndex);
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filterTrainerList().length / pageSize);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <>
            <DefaultNavbar
                routes={routes}
                sticky
            />
            <Card
                sx={{
                    height: 'auto',
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container maxWidth="sm">
                    <form>
                        <Grid container style={{ marginTop: "130px" }} spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                    <span style={{ color: 'black' }}>Search</span>{' '}
                                    <span style={{ color: 'rgb(60, 150, 190)' }}>Trainer</span>
                                </MKTypography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: '0px' }} spacing={2}>
                            <Grid item xs={12} sm={9}>
                                <div>
                                    <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                    <Autocomplete
                                        id="skills"
                                        options={skillsName}
                                        freeSolo
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Skill"
                                                variant="standard"
                                                style={{ marginTop: '10px' }}
                                                fullWidth
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <SearchIcon fontSize="medium" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}
                                        onChange={(event, value) => handleSearchChange(event, value)}
                                    />
                                </div>
                            </Grid>
                        </Grid>

                        <Container>
                            <Grid container>
                                <Grid item xs={4} style={{ marginLeft: '-50px' }}>
                                    <div style={sidebarStyles}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="h5" style={{ color: 'black', marginLeft: '8px' }}>Filters</Typography>
                                            {/* <Link href="#" onClick={onClearFilterClick} style={{ marginLeft: '65px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                                Clear Filters
                                            </Link> */}
                                            <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '65px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                            <MKButton variant="gradient" color="info" size="small" style={{ marginRight: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Location"
                                                variant="outlined"
                                                fullWidth
                                                style={{ flex: 1 }}
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                            />
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" style={{ flex: 1 }}>
                                                <InputLabel id="budget">Budget</InputLabel>
                                                <Select
                                                    labelId="budget"
                                                    label="Budget"
                                                    fullWidth
                                                    onChange={handleBudgetChange}
                                                    value={budget}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="0-1000">0-1000</MenuItem>
                                                    <MenuItem value="1000-5000">1000-5000</MenuItem>
                                                    <MenuItem value="5000-10000">5000-10000</MenuItem>
                                                    <MenuItem value="10000-20000">10000-20000</MenuItem>
                                                    <MenuItem value="&gt;20000">&gt;20000</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="travel-withinCountry-label">Travel within the country</InputLabel>
                                                <Select
                                                    labelId="travel-withinCountry-label"
                                                    label="Travel within the country"
                                                    fullWidth
                                                    onChange={(e) => setTravelWithinCountry(e.target.value)}
                                                    value={travelWithinCountry}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="travel-outsideCountry-label">Travel outside the country</InputLabel>
                                                <Select
                                                    labelId="travel-outsideCountry-label"
                                                    label="Travel outside the country"
                                                    fullWidth
                                                    onChange={(e) => setTravelOutsideCountry(e.target.value)}
                                                    value={travelOutsideCountry}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="weekend-training-label">Weekend Training</InputLabel>
                                                <Select
                                                    labelId="weekend-Training-label"
                                                    label="Weekend Training"
                                                    fullWidth
                                                    onChange={(e) => setWeekendTraining(e.target.value)}
                                                    value={weekendTraining}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="individual-training-label">Individual Training</InputLabel>
                                                <Select
                                                    labelId="individual-Training-label"
                                                    label="Individual Training"
                                                    fullWidth
                                                    onChange={(e) => setIndividualTraining(e.target.value)}
                                                    value={individualTraining}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="record-training-label">Record Training</InputLabel>
                                                <Select
                                                    labelId="record-Training-label"
                                                    label="Record Training"
                                                    fullWidth
                                                    onChange={(e) => setRecordTraining(e.target.value)}
                                                    value={recordTraining}
                                                    style={{ minHeight: '44px' }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <Autocomplete
                                                // multiple
                                                id="timeZone-autocomplete"
                                                options={timeZones}
                                                freeSolo
                                                renderTags={(value, getTagProps) =>
                                                    value.map((option, tagIndex) => (
                                                        <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                                            {option}
                                                        </span>
                                                    ))
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Working Time Zone"
                                                        variant="outlined"
                                                        style={{ minHeight: '40px', width: '290px' }}
                                                        fullWidth
                                                    />
                                                )}
                                                onChange={(event, value) => handleTimeZoneChange(value)}
                                            />
                                        </div>

                                        <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Number of Trainings Delivered</Typography>
                                        <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                            <Slider
                                                value={[minTrainingDelivered, minTrainingDelivered]}
                                                onChange={handleTrainingSliderChange}
                                                size="small"
                                                getAriaValueText={valuetext}
                                                valueLabelDisplay="auto"
                                                aria-labelledby="range-slider"
                                            />
                                        </div>
                                        <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Min1"
                                                variant="outlined"
                                                style={{ width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMinTrainingDelivered(e.target.value)}
                                                value={minTrainingDelivered}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                            <TextField
                                                label="Max1"
                                                variant="outlined"
                                                style={{ marginRight: '10px', width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMinTrainingDelivered(e.target.value)}
                                                value={maxTrainingDelivered}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                        </div>

                                        <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Total Experience</Typography>
                                        <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                            <Slider
                                                value={[minYear, maxYear]}
                                                onChange={handleSliderChange}
                                                size="small"
                                                getAriaValueText={valuetext}
                                                valueLabelDisplay="auto"
                                                aria-labelledby="range-slider"
                                            />
                                        </div>
                                        <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Min"
                                                variant="outlined"
                                                style={{ width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMinYear(e.target.value)}
                                                value={minYear}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                            <TextField
                                                label="Max"
                                                variant="outlined"
                                                style={{ marginRight: '10px', width: '100px' }}
                                                fullWidth
                                                onChange={(e) => setMaxYear(e.target.value)}
                                                value={maxYear}
                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                type="number"
                                            />
                                        </div>

                                        <Typography style={{ marginLeft: '10px', marginTop: '10px', marginRight: '20px' }} variant="h6">Last Delivered Date</Typography>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex' }}>
                                            <div>
                                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>From Date</InputLabel>
                                            </div>
                                            <MKInput
                                                type="date"
                                                id="from_date"
                                                value={fromDate || ""}
                                                onChange={handleFromDateChange}
                                                style={{ minHeight: '44px', width: '300px', marginLeft: '-80px' }}
                                                placeholder="From Date"
                                                // inputProps={{ max: today }}
                                                fullwidth
                                            />
                                        </div>
                                        <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                            <div>
                                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>To Date</InputLabel>
                                            </div>
                                            <MKInput
                                                type="date"
                                                id="to_date"
                                                value={toDate || ""}
                                                onChange={handleToDateChange}
                                                style={{ minHeight: '44px', width: '300px', marginLeft: '-60px' }}
                                                placeholder="To Date"
                                                // inputProps={{ max: today }}
                                                fullwidth
                                            />
                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={8}>
                                    <Grid container style={{ marginTop: '10px', marginBottom: '10px' }} spacing={2}>
                                        <Grid item xs={12} sm={3}>
                                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h6" color="black">
                                                {filterTrainerList() ? `${filterTrainerList().length} result${filterTrainerList().length !== 1 ? 's' : ''} found` : 'Default Training Name'}
                                            </MKTypography>
                                        </Grid>
                                    </Grid>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {getCurrentPageData().map((trainer, index) => (
                                            <Grid item xs={8} key={trainer.id} className="gridItem">
                                                <div className="gridContent">
                                                    <div className="trainingInfo" >
                                                        <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                                            <MKAvatar
                                                                src={`s3://labasservice/trainingportal/trainershub/2_thomas/profile-picture/profile-picture`}
                                                                alt="Profile Picture"
                                                                size="lg"
                                                                style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                                            />
                                                            <Typography variant="subtitle1" className="trainingName" style={{ marginTop: '10px' }}>
                                                                <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                                            </Typography>
                                                        </div>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                <LocationOn style={{ marginRight: '5px' }} /> {trainer.location} | {trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                                            </span>
                                                        </Typography>
                                                        <Typography style={{ fontSize: 'medium' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {trainer.skills}
                                                            </span>
                                                        </Typography>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-50px' }}>
                                                        <MKButton variant="outlined" color="info" size="small" onClick={() => onMoreDetailsClick(trainer)} style={{ marginTop: '-10px', padding: '5px 10px' }}>More Deatils</MKButton>
                                                    </div>
                                                </div>
                                            </Grid>
                                        ))}
                                        <div style={{ marginTop: '10px', marginLeft: '-280px', display: 'flex', justifyContent: 'center' }}>
                                            <MKButton onClick={handlePrevClick} color="info" variant="gradient" size="small" disabled={currentPage === 1}>
                                                <Icon>keyboard_arrow_left</Icon>
                                            </MKButton>
                                            {Array.from({ length: totalPages }).map((_, index) => (
                                                <MKButton
                                                    key={index}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    variant={currentPage === index + 1 ? 'gradient' : 'gradient'}
                                                    color="info"
                                                    size="small"
                                                >
                                                    {index + 1}
                                                </MKButton>
                                            ))}
                                            <MKButton onClick={handleNextClick} variant="gradient" color="info" size="small" disabled={currentPage === totalPages}>
                                                <Icon>keyboard_arrow_right</Icon>
                                            </MKButton>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </form>
                </Container>
            </Card>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                    <SimpleFooter />
                </MKBox>
            </div>
        </>
    );
}

export default Page;

